import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {CheckInService} from "../../../services/check-in.service";
import {RoleService} from "../../../role/role.service";
import { HttpResponse } from "@angular/common/http";

@Component({
    selector: 'wpl-payment',
    templateUrl: './wpl-payment.component.html',
    styleUrls: ['./wpl-payment.component.scss'],
    standalone: false
})
export class WplPaymentComponent implements OnInit {
  @Input() parentForm:UntypedFormGroup;
  @Input() value:any = {};
  @Input() disabled = false;
  @Input() request;
  @Input() clientMode = false;
  form:UntypedFormGroup = new UntypedFormGroup({payment_id: new UntypedFormControl('',Validators.required)});
  key = 'custom_params';
  working = false;
  order;
  payment;
  constructor(
    public roleService: RoleService
  ) { }

  ngOnInit() {
    this.form.patchValue(this.value || {});
    this.parentForm.addControl(this.key, this.form);
    if(this.request.order){
      this.order = this.request.order;
    }
  }
  ngOnDestroy(){
    Promise.resolve(null).then(() => {
      this.parentForm.removeControl(this.key);
    });
  }
  generatePayment(){
    
  }
  openPayment(){

  }

}
